export default __webpack_public_path__ + "static/media/hero-3.9711a5d7.jpeg";